import { useEffect } from "react";
import ContactForm from "../components/ContactForm";
import CtaBanner from "../components/CtaBanner";
import { COMPANY_INFO } from "../data/siteData";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Kontakt Kærby Tømrer- & Snedkerforretning ApS - Tlf. 26 19 20 88";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Kontakt Kærby Tømrer- & Snedkerforretning ApS for et uforpligtende tilbud på tømrer- eller snedkerarbejde. Ring på 26 19 20 88."
      );
    }
  }, []);

  return (
    <div className="bg-white min-h-screen space-y-0 text-stone-900">
      
      {/* Header */}
      <section className="relative bg-zinc-900 text-white pt-20 sm:pt-24 pb-16 sm:pb-20 border-b border-zinc-800 -mt-14 sm:-mt-16 z-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-3">
          <span className="text-[#ea580c] font-bold text-xs uppercase tracking-widest bg-zinc-950 px-3.5 py-1 rounded-full inline-block border border-zinc-800">
            Direkte Kontakt
          </span>
          <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight uppercase">
            Kontakt os for et uforpligtende tilbud
          </h1>
          <p className="text-stone-300 text-base sm:text-lg max-w-2xl">
            Har du spørgsmål eller ønsker du tilbud på et byggeprojekt? Vi sidder klar ved telefonen og tastaturet.
          </p>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="py-16 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Left Contact Details Box */}
            <div className="lg:col-span-5 space-y-8">
              <div className="bg-white p-8 rounded-2xl border border-stone-200 shadow-sm space-y-6">
                
                <h2 className="text-2xl font-bold uppercase tracking-tight text-stone-900 border-b border-stone-100 pb-4">
                  Firmadetaljer
                </h2>

                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-xl bg-zinc-900 text-[#ea580c] flex items-center justify-center text-xl shrink-0 mt-1">
                      <i className="fa-solid fa-building" aria-hidden="true" />
                    </div>
                    <div>
                      <h3 className="font-bold text-stone-900 text-base uppercase">{COMPANY_INFO.name}</h3>
                      <p className="text-sm text-stone-600 mt-0.5">{COMPANY_INFO.address}</p>
                      <p className="text-sm text-stone-600">{COMPANY_INFO.city}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 border-t border-stone-100 pt-5">
                    <div className="w-12 h-12 rounded-xl bg-zinc-900 text-[#ea580c] flex items-center justify-center text-xl shrink-0">
                      <i className="fa-solid fa-phone" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="text-xs text-stone-500 font-semibold uppercase">Telefon</p>
                      <a
                        href={`tel:${COMPANY_INFO.phoneRaw}`}
                        className="text-xl font-extrabold text-stone-900 hover:text-[#ea580c] transition-colors whitespace-nowrap"
                      >
                        +{COMPANY_INFO.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 border-t border-stone-100 pt-5">
                    <div className="w-12 h-12 rounded-xl bg-zinc-900 text-[#ea580c] flex items-center justify-center text-xl shrink-0">
                      <i className="fa-solid fa-envelope" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="text-xs text-stone-500 font-semibold uppercase">E-mail</p>
                      <a
                        href={`mailto:${COMPANY_INFO.email}`}
                        className="text-base font-bold text-stone-900 hover:text-[#ea580c] transition-colors whitespace-nowrap"
                      >
                        {COMPANY_INFO.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 border-t border-stone-100 pt-5">
                    <div className="w-12 h-12 rounded-xl bg-zinc-900 text-[#ea580c] flex items-center justify-center text-xl shrink-0">
                      <i className="fa-solid fa-id-card" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="text-xs text-stone-500 font-semibold uppercase">CVR Nummer</p>
                      <p className="text-base font-bold text-stone-900 whitespace-nowrap">
                        CVR: {COMPANY_INFO.cvr}
                      </p>
                    </div>
                  </div>
                </div>

              </div>

              {/* Service Areas Note */}
              <div className="bg-zinc-900 text-white p-6 rounded-2xl border border-zinc-800 space-y-3">
                <h3 className="font-bold text-[#ea580c] text-base uppercase flex items-center gap-2">
                  <i className="fa-solid fa-truck-ramp-box" aria-hidden="true" />
                  <span>Dækningsområde</span>
                </h3>
                <p className="text-sm text-stone-300 leading-relaxed">
                  Vi udfører tømrer- og snedkerarbejde for både private, erhverv og boligforeninger i Gjerlev, Randers, Mariager, Hadsund og omegn.
                </p>
              </div>
            </div>

            {/* Right Form Area */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>

          </div>
        </div>
      </section>

      <CtaBanner />

    </div>
  );
}
